export const CMS_NAME = "Xpitality";
export const CMS_ENDPOINT = "https://graphql.datocms.com/";
export const HOSTNAME =
  process.env.STAGE === "production"
    ? `https://${process.env.NEXT_PUBLIC_HOSTNAME}`
    : process.env.STAGE === "development" && process.env.VERCEL_URL
      ? `https://${process.env.VERCEL_URL}`
      : "http://localhost:3000";

export const DEFAULT_FALLBACK_LOCALE = "it";
export const SUPPORTED_LOCALES = ["en", "fr", "de", "it", "nl"];
